package uz.ferro.erp.feature.appuser.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.salesperson.model.SalesPersonDto

@Serializable
data class UserDto(
    val id: Long?,

    val name: String? = null,

    val username: String? = null,

    val password: String? = null,

    var role: Role? = null,

    val salesPoint: SalesPointDto? = null,

    val salesPerson: SalesPersonDto? = null,

    val permissions: List<UserPermissionDto>? = null,

    val sapEmployeeId: Long? = null,

    val sapEmployeeName: String? = null,

    val disabled: Boolean? = null,
)